const ApiSetting={
  getoOnlineByRegion:'/case-assistant/assistant/getoOnlineByRegion',//获取城市列表
  searchOnlineOrgList:'/case-assistant/assistant/searchOnlineOrgList',//搜索地区机构
  getOnlineOrgListByRegion:'/case-assistant/assistant/getOnlineOrgListByRegion',//获取地区机构列表
  queryOnlineOrgByUuid:'/case-assistant/assistant/queryOnlineOrgByUuid',//获取单个机构
  createOrder:'/case-assistant/order/createOrder',//保存订单
  orgdes:'/case-assistant/org/orgdes',//须知
  sendValidateCode:'/case-assistant/accounts/sendValidateCode',//发短信验证码
  upload:'/case-assistant/file/img/upload',//上传图片
  uploadFront:'/case-assistant/file/img/front/upload',//上传图片
  uploadback:'/case-assistant/file/img/back/upload',//上传图片
  getOrgServiceDic: '/case-assistant/assistant/getOrgServiceDic', //获取机构字典
  pay:'/case-assistant/paycenter/pay',//微信支付
  paying:'/case-assistant/paycenter/paying',//微信支付
  getordelistbyopenid:'/case-assistant/orderinfo/getordelistbyopenid',//获取订单列表
  mainInfo:'/case-assistant/assistant/mailInfo',//获取快递
  getCopyPackageInfo:'/case-assistant/assistant/getCopyPackageInfo',//需要打包配置得医院
  // selectProvince:'/case-assistant/region/selectProvince',//获取省份
  // selectCity:'/case-assistant/region/selectCity',//获取省份下的城市
  // selectVillage:'/case-assistant/region/selectVillage'//获取城市下的县
  getOpenId:'/case-assistant/weixinOAuth/getOpenId/?code=', //获取openId缓存

}
export default ApiSetting
